import { render, staticRenderFns } from "./btn-yzm.vue?vue&type=template&id=3b0a5274&scoped=true"
import script from "./btn-yzm.vue?vue&type=script&lang=js"
export * from "./btn-yzm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0a5274",
  null
  
)

export default component.exports